import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-w-sm grid gap-y-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "min-h-10 min-w-10 skeleton-loading rounded-full" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col ml-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "skeleton-loading h-4 w-24" }),
    /*#__PURE__*/_createElementVNode("span", { class: "skeleton-loading h-3 w-32 mt-2" })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "!h-8 !min-w-20 skeleton-loading rounded-btn" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "flex flex-col text-sm ml-2" }
const _hoisted_7 = { class: "text-xs text-gray-400" }
const _hoisted_8 = {
  key: 1,
  class: "text-center"
}

import { ref } from 'vue';
import {
	UiConfirmation,
	UiConfirmationRef,
	UiCard,
	UiCardDivider,
	UiAvatar,
	UiButton,
	useLoading
} from '@/ui-kit';
import { doIfRefValue, Id } from '@/utils';
import AttachTeamMemberToPhoneNumberDialog from './AttachTeamMemberToPhoneNumberDialog.vue';
import { usePhoneNumberDetails } from '../composition';
import { useToast } from 'vue-toastification';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberTeamMembers',
  setup(__props) {

const { success } = useToast();
const { loading, toggleLoading } = useLoading(true);
const {
	loading: removeLoading,
	toggleLoading: toggleRemoveLoading
} = useLoading(false);
const {
	selectedPhoneNumber,
	teamMembers,
	loadPhoneNumberMembers,
	detachTeamMember
} = usePhoneNumberDetails();

const confirmation: UiConfirmationRef = ref(null);
const attachTeamMemberDialogRef =
	ref<
		InstanceType<
			typeof AttachTeamMemberToPhoneNumberDialog
		>
	>();

const init = async () => {
	await loadPhoneNumberMembers(
		selectedPhoneNumber.value!
	);
	toggleLoading(false);
};

init();

async function removeTeamMember(memberId: number) {
	toggleRemoveLoading(false);
	const result = await confirmation.value!.openDialog(
		'Are you sure you want to detach this team member?',
		'This phone number will be unaccessable for this team member after detaching.'
	);
	if (!result) {
		return;
	}

	toggleRemoveLoading(true);
	await detachTeamMember(memberId);
	confirmation.value!.closeDialog();
	success('Team member was successfully removed.');
}

function addTeamMember() {
	attachTeamMemberDialogRef.value!.openDialog();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiCard), {
      theme: "white",
      class: "mt-8"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(UiCardDivider), {
          title: "Team members",
          subtitle: "Give other members in your workspace access to this number. <br /> Everyone sharing access can use the phone number, see calls and  messages, and incoming calls will ring all members."
        }),
        _createElementVNode("div", _hoisted_1, [
          (_unref(loading))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                return _createElementVNode("div", {
                  class: "flex items-center justify-between",
                  key: n
                }, _hoisted_4)
              }), 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(teamMembers).length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(teamMembers), (member) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex items-center justify-between",
                        key: member.id
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_unref(UiAvatar), {
                            class: "min-h-10 h-10 w-10 min-w-10",
                            avatar: 
									member?.avatar?.path
								,
                            name: member.name
                          }, null, 8, ["avatar", "name"]),
                          _createElementVNode("div", _hoisted_6, [
                            _createTextVNode(_toDisplayString(member.name) + " ", 1),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(member.email), 1)
                          ])
                        ]),
                        _createVNode(_unref(UiButton), {
                          tabindex: "0",
                          onClick: ($event: any) => (
								removeTeamMember(member.id)
							),
                          class: "!text-sm !h-8 !min-w-20 ml-4",
                          theme: "danger-outlined"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Remove ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("p", _hoisted_8, " No team members has access to this phone number. Add at least one team member to this phone number for receiving calls "))
              ], 64))
        ]),
        _createVNode(_unref(UiCardDivider)),
        _createVNode(_unref(UiButton), {
          tabindex: "0",
          onClick: addTeamMember,
          icon: "plus"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Add Team Members ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(UiConfirmation), {
      ref_key: "confirmation",
      ref: confirmation,
      loading: _unref(removeLoading)
    }, null, 8, ["loading"]),
    _createVNode(AttachTeamMemberToPhoneNumberDialog, {
      ref_key: "attachTeamMemberDialogRef",
      ref: attachTeamMemberDialogRef
    }, null, 512)
  ], 64))
}
}

})